import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const INITIAL_STATE = Immutable({
  isLoading: false,
  isAllSitesLoading: false,
  successMessage: null,
  errorMessage: null,
  sites: [],
  allSites: [],
  totalElements: 0,
  createdId: null,
  createdAddressId: null,
  controllers: [],
  siteAvailableControllers: [],
  siteAvailableControllersTotal: 0,
  customerControllers: [],
  customerControllersTotal: 0,
  controllersIsLoading: false,
});

const { Types, Creators } = createActions({
  getSitesRequest: ['customerId', 'pageParams'],
  getSitesRequestSuccess: ['sites', 'totalElements'],
  getSitesRequestFailure: ['errorMessage'],

  getAllSitesRequest: ['customerId', 'pageParams'],
  getAllSitesRequestSuccess: ['allSites', 'totalElements'],
  getAllSitesRequestFailure: ['errorMessage'],

  createSiteRequest: ['siteInfos', 'customerId', 'pageParams'],
  createSiteRequestSuccess: ['createdId', 'createdAddressId', 'sites', 'totalElements', 'successMessage'],
  createSiteRequestFailure: ['errorMessage'],

  editSiteRequest: ['siteInfos', 'customerId', 'pageParams'],
  editSiteRequestSuccess: ['sites', 'totalElements', 'successMessage'],
  editSiteRequestFailure: ['errorMessage'],

  deleteSiteRequest: ['siteId', 'customerId', 'pageParams'],
  deleteSiteRequestSuccess: ['sites', 'totalElements', 'successMessage'],
  deleteSiteRequestFailure: ['errorMessage'],

  getSiteControllersRequest: ['siteId'],
  getSiteControllersRequestSuccess: ['controllers'],
  getSiteControllersRequestFailure: ['errorMessage'],

  editSiteControllerRequest: ['controllerId', 'controllerInfos', 'siteId'],
  editSiteControllerRequestSuccess: ['controllers', 'successMessage'],
  editSiteControllerRequestFailure: ['errorMessage'],

  deleteSiteControllerRequest: ['siteId', 'data'],
  deleteSiteControllerRequestSuccess: ['controllers', 'successMessage'],
  deleteSiteControllerRequestFailure: ['errorMessage'],

  getSiteAvailableControllersRequest: ['pageParams', 'customerId'],
  getSiteAvailableControllersRequestSuccess: ['siteAvailableControllers', 'siteAvailableControllersTotal'],
  getSiteAvailableControllersRequestFailure: ['errorMessage'],

  getCustomerControllersRequest: ['customerId', 'pageParams'],
  getCustomerControllersRequestSuccess: ['customerControllers', 'customerControllersTotal'],
  getCustomerControllersRequestFailure: ['errorMessage'],

  addControllerToSiteRequest: ['siteId', 'data', 'customerId', 'distributorId'],
  addControllerToSiteRequestSuccess: ['controllers', 'successMessage'],
  addControllerToSiteRequestFailure: ['errorMessage'],

  resetSites: null,
  resetControllers: null,
  resetCustomerControllers: null,
});

export const getSitesRequest = (state) => state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const getSitesRequestSuccess = (state, { sites, totalElements }) =>
  state.merge({ isLoading: false, sites, totalElements });
export const getSitesRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage, sites: [], totalElements: 0 });

export const getAllSitesRequest = (state) =>
  state.merge({ isAllSitesLoading: true, successMessage: null, errorMessage: null });
export const getAllSitesRequestSuccess = (state, { allSites, totalElements }) =>
  state.merge({ isAllSitesLoading: false, allSites, totalElements });
export const getAllSitesRequestFailure = (state, { errorMessage }) =>
  state.merge({ isAllSitesLoading: false, errorMessage, allSites: [], totalElements: 0 });

export const createSiteRequest = (state) => state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const createSiteRequestSuccess = (
  state,
  { createdId, createdAddressId, sites, totalElements, successMessage }
) => state.merge({ isLoading: false, createdId, createdAddressId, sites, totalElements, successMessage });
export const createSiteRequestFailure = (state, { errorMessage }) => state.merge({ isLoading: false, errorMessage });

export const editSiteRequest = (state) => state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const editSiteRequestSuccess = (state, { sites, totalElements, successMessage }) =>
  state.merge({ isLoading: false, sites, totalElements, successMessage });
export const editSiteRequestFailure = (state, { errorMessage }) => state.merge({ isLoading: false, errorMessage });

export const deleteSiteRequest = (state) => state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const deleteSiteRequestSuccess = (state, { sites, totalElements, successMessage }) =>
  state.merge({ isLoading: false, sites, totalElements, successMessage });
export const deleteSiteRequestFailure = (state, { errorMessage }) => state.merge({ isLoading: false, errorMessage });

export const getSiteControllersRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const getSiteControllersRequestSuccess = (state, { controllers }) =>
  state.merge({ isLoading: false, controllers });
export const getSiteControllersRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const editSiteControllerRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const editSiteControllerRequestSuccess = (state, { controllers, successMessage }) =>
  state.merge({ isLoading: false, controllers, successMessage });
export const editSiteControllerRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const deleteSiteControllerRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const deleteSiteControllerRequestSuccess = (state, { controllers, successMessage }) =>
  state.merge({ isLoading: false, controllers, successMessage });
export const deleteSiteControllerRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const getCustomerControllersRequest = (state) =>
  state.merge({ controllersIsLoading: true, successMessage: null, errorMessage: null });
export const getCustomerControllersRequestSuccess = (state, { customerControllers, customerControllersTotal }) =>
  state.merge({ controllersIsLoading: false, customerControllers, customerControllersTotal });
export const getCustomerControllersRequestFailure = (state, { errorMessage }) =>
  state.merge({ controllersIsLoading: false, errorMessage });

export const getSiteAvailableControllersRequest = (state) =>
  state.merge({ controllersIsLoading: true, successMessage: null, errorMessage: null });
export const getSiteAvailableControllersRequestSuccess = (
  state,
  { siteAvailableControllers, siteAvailableControllersTotal }
) => state.merge({ controllersIsLoading: false, siteAvailableControllers, siteAvailableControllersTotal });
export const getSiteAvailableControllersRequestFailure = (state, { errorMessage }) =>
  state.merge({ controllersIsLoading: false, errorMessage });

export const addControllerToSiteRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const addControllerToSiteRequestSuccess = (state, { controllers, successMessage }) =>
  state.merge({ isLoading: false, controllers, successMessage });
export const addControllerToSiteRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const resetSites = (state) => state.merge({ sites: [], allSites: [], totalElements: 0 });
export const resetControllers = (state) => state.merge({ controllers: [] });
export const resetCustomerControllers = (state) =>
  state.merge({ customerControllers: [], customerControllersTotal: 0 });

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_SITES_REQUEST]: getSitesRequest,
  [Types.GET_SITES_REQUEST_SUCCESS]: getSitesRequestSuccess,
  [Types.GET_SITES_REQUEST_FAILURE]: getSitesRequestFailure,

  [Types.GET_ALL_SITES_REQUEST]: getAllSitesRequest,
  [Types.GET_ALL_SITES_REQUEST_SUCCESS]: getAllSitesRequestSuccess,
  [Types.GET_ALL_SITES_REQUEST_FAILURE]: getAllSitesRequestFailure,

  [Types.CREATE_SITE_REQUEST]: createSiteRequest,
  [Types.CREATE_SITE_REQUEST_SUCCESS]: createSiteRequestSuccess,
  [Types.CREATE_SITE_REQUEST_FAILURE]: createSiteRequestFailure,

  [Types.EDIT_SITE_REQUEST]: editSiteRequest,
  [Types.EDIT_SITE_REQUEST_SUCCESS]: editSiteRequestSuccess,
  [Types.EDIT_SITE_REQUEST_FAILURE]: editSiteRequestFailure,

  [Types.DELETE_SITE_REQUEST]: deleteSiteRequest,
  [Types.DELETE_SITE_REQUEST_SUCCESS]: deleteSiteRequestSuccess,
  [Types.DELETE_SITE_REQUEST_FAILURE]: deleteSiteRequestFailure,

  [Types.GET_SITE_CONTROLLERS_REQUEST]: getSiteControllersRequest,
  [Types.GET_SITE_CONTROLLERS_REQUEST_SUCCESS]: getSiteControllersRequestSuccess,
  [Types.GET_SITE_CONTROLLERS_REQUEST_FAILURE]: getSiteControllersRequestFailure,

  [Types.EDIT_SITE_CONTROLLER_REQUEST]: editSiteControllerRequest,
  [Types.EDIT_SITE_CONTROLLER_REQUEST_SUCCESS]: editSiteControllerRequestSuccess,
  [Types.EDIT_SITE_CONTROLLER_REQUEST_FAILURE]: editSiteControllerRequestFailure,

  [Types.DELETE_SITE_CONTROLLER_REQUEST]: deleteSiteControllerRequest,
  [Types.DELETE_SITE_CONTROLLER_REQUEST_SUCCESS]: deleteSiteControllerRequestSuccess,
  [Types.DELETE_SITE_CONTROLLER_REQUEST_FAILURE]: deleteSiteControllerRequestFailure,

  [Types.GET_SITE_AVAILABLE_CONTROLLERS_REQUEST]: getSiteAvailableControllersRequest,
  [Types.GET_SITE_AVAILABLE_CONTROLLERS_REQUEST_SUCCESS]: getSiteAvailableControllersRequestSuccess,
  [Types.GET_SITE_AVAILABLE_CONTROLLERS_REQUEST_FAILURE]: getSiteAvailableControllersRequestFailure,

  [Types.GET_CUSTOMER_CONTROLLERS_REQUEST]: getCustomerControllersRequest,
  [Types.GET_CUSTOMER_CONTROLLERS_REQUEST_SUCCESS]: getCustomerControllersRequestSuccess,
  [Types.GET_CUSTOMER_CONTROLLERS_REQUEST_FAILURE]: getCustomerControllersRequestFailure,

  [Types.ADD_CONTROLLER_TO_SITE_REQUEST]: addControllerToSiteRequest,
  [Types.ADD_CONTROLLER_TO_SITE_REQUEST_SUCCESS]: addControllerToSiteRequestSuccess,
  [Types.ADD_CONTROLLER_TO_SITE_REQUEST_FAILURE]: addControllerToSiteRequestFailure,

  [Types.RESET_SITES]: resetSites,
  [Types.RESET_CONTROLLERS]: resetControllers,
  [Types.RESET_CUSTOMER_CONTROLLERS]: resetCustomerControllers,
});

export const SitesTypes = Types;
export default Creators;
